<gtapp-gt-table
  [desktopTableBackendData]="sopDataList"
  [desktopTableDetails]="tableDetailSOP"
  [otherParams]="otherParamsSOP"
  (searchColumn)="searchColumnSOP($event)"
  (sortColumn)="sortColumnSOP($event)"
  (paginationChange)="onChangePaginationSOP($event)"
  (rowClick)="onRowClick($event, viewSOPFileTemplate)"
>
</gtapp-gt-table>

<ng-container
  ><div class="mt-1 mx-1">
    <div class="fixed-add-btn">
      <button class="btn btn-lg w-100 btn-primary" [routerLink]="['/add-sop']">
        <span><i class="fa-solid fa-plus"></i></span>
      </button>
    </div></div
></ng-container>

<ng-template
  #viewSOPFileTemplate
  let-viewSOPFileTemplateRef="dialogRef"
  let-data
>
  <div class="dialog-box card">
    <div class="card-header">
      <span class="float-end" (click)="viewSOPFileTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    @if (data?.dblClicked) {
      <iframe
        [src]="data?.pdfUrl"
        frameborder="0"
        allowfullscreen="true"
        allow="fullscreen"
      ></iframe>
    } @else {
      <div class="pdf-container" (dblclick)="data.dblClicked = true">
        <object [data]="data?.pdfUrl" type="application/pdf" class="pdf-object">
          <p>
            Your browser does not support PDFs.
            <a [href]="data?.file_url" target="_blank">Download PDF</a>.
          </p>
        </object>
      </div>
    }
  </div>
</ng-template>
